import Vue from 'vue'
import Vuex from 'vuex'
import {businessProfile} from "@/store/modules/onboarding/businessProfile";
import {businessAddress} from "@/store/modules/onboarding/businessAddress";
import {businessStructure} from "@/store/modules/onboarding/businessStructure";
import {bankAccountForPayouts} from "@/store/modules/onboarding/bankAccountForPayouts";
import {additionalUnderwritingData} from "@/store/modules/onboarding/additionalUnderwritingData";
import {stakeholdersDetails} from "@/store/modules/onboarding/stakeholderDetails";
import {onboarding} from "@/store/modules/onboarding/onboarding";
import {app} from "@/store/modules/app";
import {agreementAcceptance} from "@/store/modules/onboarding/agreementAcceptance";
import {disputes} from "@/store/modules/onboarding/disputes";
import {merchantBalanceReserve} from "@/store/modules/merchantBalanceReserve";
import {merchantPayfacDetails} from "@/store/modules/merchantPayfacDetails";
import {essentials} from "@/store/modules/incremental-onboarding/essentials";
import {
    incrementalOnboardingBusinessAddress
} from "@/store/modules/incremental-onboarding/incrementalOnboardingbusinessAddress";
import {
    incrementalOnboardingBusinessProfile
} from "@/store/modules/incremental-onboarding/incrementalOnboardingbusinessProfile";
import {businessRegistration} from "@/store/modules/incremental-onboarding/businessRegistration";

Vue.use(Vuex)

export default new Vuex.Store({
    state: {},
    getters: {},
    mutations: {},
    actions: {},
    plugins: [], // set logger only for development
    modules: {
        onboarding,
        essentials,
        incrementalOnboardingBusinessAddress,
        incrementalOnboardingBusinessProfile,
        businessRegistration,
        businessProfile,
        businessAddress,
        businessStructure,
        bankAccountForPayouts,
        additionalUnderwritingData,
        stakeholdersDetails,
        app,
        agreementAcceptance,
        disputes,
        merchantBalanceReserve,
        merchantPayfacDetails
    }
})
